import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, ArrowRight, Lock, MailIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-10 px-4 md:pt-20 md:pb-24 bg-brand-cream overflow-hidden" data-id="element-134">
      <div className="max-w-7xl mx-auto" data-id="element-135">
        {/* Social proof badge — centered above the grid */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-6 lg:mb-10" data-id="element-136">
          <div className="flex items-center gap-2 bg-brand-sage w-fit px-3 py-1 rounded-full text-brand-green text-sm font-bold" data-id="element-137">
            <div className="flex" data-id="element-138">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-139" />)}
            </div>
            <span data-id="element-140">Más de 2,400 alumnas satisfechas</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start" data-id="element-141">
          {/* Image — left on desktop, below text on mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-2 lg:order-1 w-full max-w-md mx-auto lg:max-w-none" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/jYRhaidp2pvb8S61D63d5x/Pack3ebboks.webp" alt="Panadería Artesanal Sin Gluten — Pack de ebooks y recetas" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-143" />
          </motion.div>

          {/* Text Content — right on desktop, first on mobile */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          staggerChildren: 0.2
        }} className="flex flex-col gap-3 md:gap-6 order-1 lg:order-2" data-id="element-144">
            <motion.h1 className="md:text-2xl lg:text-4xl font-heading font-bold text-brand-brown text-[28px]" data-id="element-145">
              ¿Deseas Transformar tu Alimentación Sin Gluten Aburrida e Insípida
              en{' '}
              <span className="text-brand-terracotta italic" data-id="element-146">
                Pan Real, Pasteles Esponjosos y Postres Irresistibles
              </span>
              ?
            </motion.h1>

            <motion.p className="text-lg md:text-xl text-brand-brownLight leading-relaxed" data-id="element-147">
              Porque mereces volver a disfrutar el{' '}
              <span className="text-brand-terracotta font-bold" data-id="element-148">pan</span>,
              celebrar con un{' '}
              <span className="text-brand-terracotta font-bold" data-id="element-149">
                pastel de verdad
              </span>{' '}
              y terminar cada comida con un{' '}
              <span className="text-brand-terracotta font-bold" data-id="element-150">
                postre irresistible
              </span>
            </motion.p>

            <motion.div className="mt-2 md:mt-4 flex flex-col gap-3 md:gap-4" data-id="element-151">
              <a href="#oferta" className="group relative flex items-center justify-center gap-3 bg-brand-terracotta hover:bg-brand-terracottaHover text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(196,93,44,0.3)] transition-all hover:-translate-y-1 w-full sm:w-fit" data-id="element-152">
                ¡QUIERO EL COMBO 3×1 AHORA! ➤
              </a>

              <div className="flex flex-wrap items-center gap-4 text-sm font-medium text-brand-brownLight" data-id="element-153">
                <span className="flex items-center gap-1" data-id="element-154">
                  <MailIcon className="w-4 h-4 text-brand-green" data-id="element-155" /> Acceso
                  Inmediato al Email
                </span>
                <span className="hidden sm:inline" data-id="element-156">•</span>
                <span className="flex items-center gap-1" data-id="element-157">
                  <Lock className="w-4 h-4 text-brand-green" data-id="element-158" /> Compra 100%
                  Segura
                </span>
                <span className="hidden sm:inline" data-id="element-159">•</span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}